import React from 'react';
import {
    Container,
    Description,
    Content,
    Title,
    Point
} from './style';

import {
    Link
} from 'react-router-dom';
import LoadingBar from 'react-top-loading-bar';
import MaterialTable from 'material-table';
import {
    createMuiTheme,
    ThemeProvider,
    Card,
    CardContent,
    Typography
} from '@material-ui/core';
import { NewLine } from './style';
import './style.css';
import { Modal } from 'antd';
import ReactCountryFlag from "react-country-flag"

var moment = require('moment');

class Covid19 extends React.Component {
    state = {
        loadingBarProgress: Math.random() * 100,
        allData: {
            Global: {
                NewConfirmed: 0,
                TotalConfirmed: 0,
                NewDeaths: 0,
                TotalDeaths: 0,
                NewRecovered: 0,
                TotalRecovered: 0
            }
        },
        last_update: "-"
    };

    dataLoadError = () => {
        Modal.error({
            title: 'Data Loading Error!',
            content: 'Data cannot be fetched, please reload this page',
            centered: true
        });
    }


    complete = () => {
        this.setState({ loadingBarProgress: 100 });
    };

    onLoaderFinished = () => {
        this.setState({ loadingBarProgress: 0 });
    };

    componentDidMount() {

        let xhr = new XMLHttpRequest();
        let json_obj = false;
        xhr.open("GET", "https://api.covid19api.com/summary", true);
        xhr.onload = function (e) {
            if (xhr.readyState === 4) {
                if (xhr.status === 200) {
                    json_obj = JSON.parse(xhr.responseText);
                    this.setState({ allData: json_obj });
                    this.setState({ data: json_obj.Countries });
                    const formattedDate = moment(json_obj.Date).format("LLLL");

                    this.setState({ last_update: formattedDate });
                    // this.setState({ global_data: json_obj.Global });
                    this.complete();
                } else {
                    this.dataLoadError();
                }
            }
        }.bind(this);
        xhr.onerror = function (e) {
            console.error(xhr.statusText);
        };
        xhr.send(null);
    }

    render() {
        // Create table theme
        const theme = createMuiTheme({
            typography: {
                fontFamily: [
                    '-apple-system',
                    'BlinkMacSystemFont',
                    '"Segoe UI"',
                    'Roboto',
                    '"Helvetica Neue"',
                    'Arial',
                    'sans-serif',
                    '"Apple Color Emoji"',
                    '"Segoe UI Emoji"',
                    '"Segoe UI Symbol"',
                ].join(','),
            },
        });

        // Define pagesize & pagesizeoption data (default = desktop)
        let pageSize = 50;
        let pageSizeOptions = [25, 50, 100];
        if (window.innerWidth < 480) {
            pageSize = 25;
        }

        const columns = [
            {
                title: "",
                sorting: false,
                width: "auto",
                render: rowData => {
                    const cc = rowData.CountryCode;
                    return (
                        <div><ReactCountryFlag countryCode={cc} svg /></div>
                    )
                }
            },
            {
                title: "Country Name",
                field: "Country"
            },
            {
                title: "New Cases",
                field: "NewConfirmed",
                type: "numeric",
                width: "15%",
                render: rowData => {
                    return (rowData.NewConfirmed).toLocaleString('en-US')
                }
            },
            {
                title: "Total Cases",
                field: "TotalConfirmed",
                defaultSort: "desc",
                type: "numeric",
                width: "11%",
                render: rowData => {
                    return (rowData.TotalConfirmed).toLocaleString('en-US')
                }
            },
            {
                title: "New Deaths",
                field: "NewDeaths",
                type: "numeric",
                width: "11%",
                render: rowData => {
                    return (rowData.NewDeaths).toLocaleString('en-US')
                }
            },
            {
                title: "Total Deaths",
                field: "TotalDeaths",
                type: "numeric",
                width: "11%",
                render: rowData => {
                    return (rowData.TotalDeaths).toLocaleString('en-US')
                }
            },
            {
                title: "New Recovered",
                field: "NewRecovered",
                type: "numeric",
                width: "11%",
                render: rowData => {
                    return (rowData.NewRecovered).toLocaleString('en-US')
                }
            },
            {
                title: "Total Recovered",
                field: "TotalRecovered",
                type: "numeric",
                width: "11%",
                render: rowData => {
                    return (rowData.TotalRecovered).toLocaleString('en-US')
                }
            }
        ]

        return (
            <Container>
                <LoadingBar
                    progress={this.state.loadingBarProgress}
                    height={3}
                    color='#fff'
                    onLoaderFinished={() => this.onLoaderFinished()}
                />
                <Link to="/"><Title> {"{"} nightbot.dev {"}"} </Title></Link>
                <Description><Point> Global Covid-19 Stats </Point></Description>
                <Content>
                    <NewLine />
                    A war between human race against unseen forces ⚔
                    <NewLine />
                    <NewLine />
                    <NewLine />

                    <div style={{
                        display: "flex",
                        justifyContent: "center",
                        flexWrap: "wrap"
                    }}>
                        <Card style={{
                            margin: "10px"
                        }}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    New Cases
                            </Typography>
                                <Typography variant="h5" component="h2">
                                    {parseInt(this.state.allData.Global.NewConfirmed).toLocaleString('en-US')}
                                </Typography>
                                <Typography variant="body2" component="p">
                                    Newly reported cases in all countries
                            </Typography>
                            </CardContent>
                        </Card>
                        <Card style={{
                            margin: "10px"
                        }}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Total Cases
                            </Typography>
                                <Typography variant="h5" component="h2">
                                    {parseInt(this.state.allData.Global.TotalConfirmed).toLocaleString('en-US')}
                                </Typography>
                                <Typography variant="body2" component="p">
                                    Total confirmed cases in all countries
                            </Typography>
                            </CardContent>
                        </Card>
                        <Card style={{
                            margin: "10px"
                        }}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Total Deaths
                            </Typography>
                                <Typography variant="h5" component="h2">
                                    {parseInt(this.state.allData.Global.TotalRecovered).toLocaleString('en-US')}
                                </Typography>
                                <Typography variant="body2" component="p">
                                    Total confirmed deaths in all countries
                            </Typography>
                            </CardContent>
                        </Card>
                        <Card style={{
                            margin: "10px"
                        }}>
                            <CardContent>
                                <Typography color="textSecondary" gutterBottom>
                                    Total Recovered
                            </Typography>
                                <Typography variant="h5" component="h2">
                                    {parseInt(this.state.allData.Global.TotalDeaths).toLocaleString('en-US')}
                                </Typography>
                                <Typography variant="body2" component="p">
                                    Total recovered patients in all countries
                            </Typography>
                            </CardContent>
                        </Card>
                    </div>

                    <NewLine />
                        Last update: {this.state.last_update}
                    <NewLine />
                    <NewLine />
                    {/* Global Cases: {this.state.global_data.TotalConfirmed} */}

                    <ThemeProvider theme={theme}>
                        <MaterialTable
                            title="🚑 Cases By Country"
                            columns={columns}
                            data={this.state.data}
                            options={{
                                pageSize: pageSize,
                                pageSizeOptions: pageSizeOptions,
                                headerStyle: { position: "sticky", top: 0 },
                                maxBodyHeight: "80vh"
                            }}
                        />
                    </ThemeProvider>

                    <NewLine />
                    Data source: <a href="https:/covid19api.com" target="_blank" rel="noopener noreferrer"
                        style={{
                            textDecoration: "none",
                            color: "#fff"
                        }}>Covid19API.com</a>
                </Content>
            </Container>
        );
    }
}

export default Covid19;